// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-partnership-summary {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #D3E1ED;
  height: 10px;
  align-items: center;
  padding: 20px 30px;
  font-size: 12px;
  color: #142A31;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AACD","sourcesContent":[".home-partnership-summary {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tborder-bottom: 1px solid #D3E1ED;\n\theight: 10px;\n\talign-items: center;\n\tpadding: 20px 30px;\n\tfont-size: 12px;\n\tcolor: #142A31;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
